import { AzureApp } from "./azure-app.interface";

export class AzureAppStore{
    userAzureApps! : AzureApp[];
    allAzureApps!  : AzureApp[];
    userRoles!     : string[];
    selectedApp!   : AzureApp;
}